import type { QueryKeyReturnType } from '@inflearn/codegen-wrapper';

import {
  API_ENDPOINT,
  getClientApiV1MockInterviewVoucherQueryOptions,
  useClientApiV1MockInterviewVoucherQuery,
} from '../../resources/@types/studyAgentSchema';

interface UseClientV1MockInterviewVoucherQuery {
  options?: Parameters<typeof useClientApiV1MockInterviewVoucherQuery>[0]['options'];
}

export function useMockInterviewVoucherQuery({ options }: UseClientV1MockInterviewVoucherQuery) {
  return useClientApiV1MockInterviewVoucherQuery({
    queryKey: getMockInterviewVoucherQueryKey(),
    url: getMockInterviewVoucherUrl(),
    options,
  });
}

export const getMockInterviewVoucherQueryKey = (): QueryKeyReturnType => [
  API_ENDPOINT.CLIENT_V1_MOCK_INTERVIEW_VOUCHER,
];

export const getMockInterviewVoucherUrl = (): string =>
  API_ENDPOINT.CLIENT_V1_MOCK_INTERVIEW_VOUCHER;

export function getMockInterviewVoucherQueryOptions() {
  return getClientApiV1MockInterviewVoucherQueryOptions({
    queryKey: getMockInterviewVoucherQueryKey(),
    url: getMockInterviewVoucherUrl(),
  });
}

export default useMockInterviewVoucherQuery;
